import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BarChart3 } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import Breadcrumbs, { toLdItems } from "@/components/Breadcrumbs";
import { buildBreadcrumbLd } from "@/lib/seo";
import { useSeoT, PAGE_META } from "@/lib/seoPagesI18n";

export default function EtudesIndex() {
  const { t: st, lang } = useSeoT();
  const meta = (PAGE_META[lang] || PAGE_META.fr).etudes;
  const et = st.etudes;
  const bc = [{ name: st.bc.home, path: "/" }, { name: st.bc.etudes, path: "/etudes" }];
  return (
    <div className="min-h-screen bg-white text-[#0A0F2C]" data-testid="etudes-index">
      <Seo title={meta.title} description={meta.desc} path="/etudes" noindex jsonLd={buildBreadcrumbLd(toLdItems(bc))} />
      <Header />
      <section className="relative bg-[#0A0F2C] text-white overflow-hidden pt-28 md:pt-36 pb-14 md:pb-20 px-5 sm:px-8 md:px-10 lg:px-14">
        <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(ellipse at top right, rgba(45,91,255,0.4), transparent 55%)" }} />
        <div className="relative mx-auto" style={{ maxWidth: "1280px" }}>
          <div className="mb-6"><Breadcrumbs items={bc} variant="dark" /></div>
          <h1 className="font-extrabold text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.02] max-w-3xl" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{et.h1}</h1>
          <p className="mt-5 text-white/80 text-base md:text-lg max-w-2xl">{et.heroSub}</p>
        </div>
      </section>
      <section className="py-16 md:py-24 px-5 sm:px-8 md:px-10 lg:px-14 bg-white">
        <div className="mx-auto" style={{ maxWidth: "1280px" }}>
          <Link to="/etudes/barometre-prix-demenagement-vaud-2026" className="group block rounded-3xl bg-[#F7F7F8] hover:bg-[#EAF0FF] p-8 transition-colors" data-testid="etude-barometre-link">
            <div className="w-11 h-11 rounded-xl bg-white text-[#2D5BFF] inline-flex items-center justify-center shadow-sm"><BarChart3 size={20} /></div>
            <h2 className="mt-4 font-extrabold text-2xl group-hover:text-[#2D5BFF] transition-colors" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{et.cardTitle}</h2>
            <p className="mt-2 text-[#4B5563]">{et.cardText}</p>
            <div className="mt-4 inline-flex items-center gap-1.5 text-[#2D5BFF] font-bold text-sm">{et.discover} <ArrowRight size={14} /></div>
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
